import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import User from "../interfaces/User";

const initialVal: User = {"id": 0,
    "managerId": null,
    "login": '',
    "firstName": '',
    "lastName": '',
    "fullName": '',
    "middleName": '',
    "email": '',
    "phone": '',
    "language": '',
    "creditLimit": 0,
    "isSendUpdates": false,
    "lastVisit": '',
    "exchangeRate": 0,
    "exchangeRateWS": 0,
    "balance": 0,
    "roles": [],
    "userPermissions": [],
    "tableSettings": {},
    "useNPNameByDefault" : false,
    "npClientName" : '',
    "isPaymentControlEnabled" : false,
    "currency": "USD",
    "rrpCurrency": "UAH",
    "managers": [{
            "id" : 0,
            "position": 0,
            "name": '',
            "phone": '',
            "email": '',
            "bankDetails": {
                "name": "",
                "accountNumber": "",
                "taxNumber": "",
                "bankNumber": ""
            }
        }
    ],
    "defaultWarehouseId": 0,
}

export const userSlice = createSlice({
        name: 'user',
        initialState: {
            value: initialVal,
        },
        reducers: {
            setUser: (state, action: PayloadAction<User>) => {
                state.value = action.payload
            },
            updateMessageStatus: (state, action: PayloadAction<boolean>) => {
                state.value.isSendUpdates = action.payload
            },
            updateUserNPKey: (state, action: PayloadAction<boolean>) => {
                state.value.useNPNameByDefault = action.payload
            }
            ,
            updateUserNpClientName: (state, action: PayloadAction<string | null>) => {
                state.value.npClientName = action.payload
            }
        }
    }
);

export const {
    setUser,
    updateMessageStatus,
    updateUserNPKey,
    updateUserNpClientName } = userSlice.actions

export default userSlice.reducer